<template>
  <div id="app">
    <!-- 載入畫面 -->
    <div id="loading-screen" class="loading-screen" v-show="isLoading">
      <div class="logo-circle">
        <img src="@/assets/picture/AW LOGO.png" alt="Hotel Logo" />
      </div>
    </div>

    <!-- 導航列 -->
    <header class="navbar" v-if="!$route.meta.hideNavbar">
      <div class="navbar-container">
        <div class="logo">
          <!-- 圓形 LOGO -->
          <router-link to="/">
            <div class="logo-circle">
              <img src="@/assets/picture/AW LOGO.png" alt="Hotel Logo" />
            </div>
          </router-link>
          <!-- 酒店名稱 -->
          <div class="hotel-name">
            <span class="hotel-name">翎藍秘境酒店</span>
            <span class="hotel-name-en">Azure Wing Hotel</span>
          </div>
        </div>

        <!-- 漢堡選單按鈕 -->
        <div class="hamburger" @click="toggleMenu">☰</div>

        <!-- 導覽選單 -->
        <ul :class="{ active: isMenuOpen }">
          <li>
            <!-- 首頁按鈕 -->
            <router-link to="/" @click="handleMenuItemClick">首頁</router-link>
            <!-- 導向首頁 -->
          </li>

          <li>
            <!-- 立即訂房按鈕 -->
            <router-link to="/booking" @click="handleMenuItemClick"
              >立即訂房</router-link
            >
            <!-- 導向立即訂房頁面 -->
          </li>

          <li>
            <!-- 飯店介紹的下拉式選單 -->
            <div class="dropdown">
              <a class="dropdown-button" @click="toggleDropdown">飯店介紹</a>
              <div class="dropdown-menu">
                <router-link
                  to="/room"
                  class="dropdown-item"
                  @click="handleMenuItemClick"
                  >客房介紹</router-link
                >
                <router-link
                  to="/spa"
                  class="dropdown-item"
                  @click="handleMenuItemClick"
                  >湯屋介紹</router-link
                >
                <router-link
                  to="/food"
                  class="dropdown-item"
                  @click="handleMenuItemClick"
                  >餐飲美饌</router-link
                >
                <router-link
                  to="/leisure-facilities"
                  class="dropdown-item"
                  @click="handleMenuItemClick"
                  >休閒設施介紹</router-link
                >
              </div>
            </div>
          </li>
          <li>
            <router-link to="/news" @click="handleMenuItemClick"
              >最新消息</router-link
            >
          </li>
          <li>
            <router-link to="/travel" @click="handleMenuItemClick"
              >景點探索</router-link
            >
          </li>
          <li>
            <router-link to="/contactus" @click="handleMenuItemClick"
              >聯絡我們</router-link
            >
          </li>
          <li class="member-menu">
            <!-- 會員圖標 -->
            <a @click.prevent="handleMemberClick">
              <img
                src="@/assets/picture/user.png"
                alt="Login"
                class="login-icon"
              />
            </a>
          </li>
        </ul>
      </div>
    </header>

    <!-- 頁面內容區域 -->
    <main>
      <router-view></router-view>
    </main>

    <!-- 頁尾 -->
    <footer class="footer" v-if="!$route.meta.hideFooter">
      <div class="footer-container">
        <!-- 左側資訊 -->
        <div class="footer-info">
          <div class="footer-logo-container">
            <img
              src="@/assets/picture/AW LOGO.png"
              alt="酒店 Logo"
              class="footer-logo"
            />
            <h3>翎藍秘境酒店</h3>
          </div>
          <div class="footer-contact">
            <p>地址：231新北市新店區銀河越嶺步道1號</p>
            <p>電話：02-8888-8888</p>
            <p>信箱：lovechristy1115@gmail.com</p>
            <p>LINE：@uiq1112i</p>
          </div>
          <div class="social-icons">
            <a href="https://www.facebook.com/share/19Uozy7WA9/"
              ><i class="fab fa-facebook-f"></i
            ></a>
            <a
              href="https://www.instagram.com/___christylove___?igsh=anJ6OGQ4eWV1Z2Ru"
              ><i class="fab fa-instagram"></i
            ></a>
            <a href="https://lin.ee/kP7rCVD"><i class="fab fa-line"></i></a>
          </div>
        </div>

        <!-- 右側地圖 -->
        <div class="footer-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d97379.08553615914!2d121.47178580035077!3d24.902350168739808!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34680035554023c5%3A0xd5265b4d2872f3ee!2z6YqA5rKz5rSe!5e0!3m2!1szh-TW!2stw!4v1735540174322!5m2!1szh-TW!2stw"
            width="100%"
            height="500"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
      <!-- 🔥 新版版權宣告 footer-bottom -->
      <div class="footer-bottom">
        <p>© {{ new Date().getFullYear() }} 翎藍秘境酒店 版權所有</p>
        <p>Design by 彩虹小馬工作室</p>
      </div>
    </footer>
  </div>
</template>

<script>
import menuController from "@/assets/js/menuController.js"; // 引入外部邏輯

export default {
  name: "App",
  mixins: [menuController], // 使用 mixin 載入邏輯
  data() {
    return {
      isMenuOpen: false,
      isLoading: true,
      showDropdown: false, // 控制會員下拉選單顯示
      isLoggedIn: false, // 控制登入狀態
    };
  },

  // ✅ 新增：監聽路由變化
  watch: {
    $route() {
      // 當路由改變時，關閉選單
      this.closeMenu();
    },
  },

  // ✅ 新增：生命週期掛載
  mounted() {
    // 監聽點擊事件，點擊選單外區域時關閉選單
    document.addEventListener("click", this.handleClickOutside);
  },

  // ✅ 新增：清理事件監聽器
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen; // 切換選單顯示狀態
    },

    // ✅ 新增：關閉選單方法
    closeMenu() {
      this.isMenuOpen = false;
      this.closeDropdowns(); // 同時關閉下拉選單
    },

    // ✅ 新增：點擊外部區域關閉選單
    handleClickOutside(event) {
      const navbar = document.querySelector(".navbar");

      // 如果點擊的不是導航列內容，就關閉選單
      if (navbar && !navbar.contains(event.target) && this.isMenuOpen) {
        this.closeMenu();
      }
    },

    // ✅ 新增：處理RWD下拉選單
    toggleDropdown(event) {
      if (window.innerWidth <= 1079) {
        // 只在RWD模式下執行
        event.preventDefault();
        const dropdown = event.target.closest(".dropdown");

        // 切換當前下拉選單的active狀態
        dropdown.classList.toggle("active");

        // 關閉其他可能開啟的下拉選單
        const allDropdowns = document.querySelectorAll(".dropdown");
        allDropdowns.forEach((item) => {
          if (item !== dropdown) {
            item.classList.remove("active");
          }
        });
      }
    },

    // ✅ 新增：點擊其他地方時關閉下拉選單
    closeDropdowns() {
      if (window.innerWidth <= 1079) {
        const allDropdowns = document.querySelectorAll(".dropdown");
        allDropdowns.forEach((item) => {
          item.classList.remove("active");
        });
      }
    },

    // ✅ 新增：處理選單項目點擊
    handleMenuItemClick() {
      // 當點擊選單項目時關閉選單（給router-link使用）
      this.closeMenu();
    },
  },
};
</script>

<style scoped>
/* 導入外部樣式檔案 */
@import "@/assets/css/styles.css";
@import "@/assets/css/carousel.css"; /* 載入輪播圖樣式 */

/* 載入畫面樣式 */
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeOut 3s forwards;
}

.loading-screen .logo-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.loading-screen .logo-circle img {
  width: auto;
  height: 218%;
  margin-top: 31%;
  margin-right: 4px;
  object-fit: cover;
}

/* 淡出動畫 */
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}

/* 載入畫面響應式調整 */
@media (max-width: 768px) {
  .loading-screen .logo-circle {
    width: 80px;
    height: 80px;
  }

  .loading-screen .logo-circle img {
    height: 200%;
    margin-top: 25%;
  }
}

@media (max-width: 480px) {
  .loading-screen .logo-circle {
    width: 60px;
    height: 60px;
  }

  .loading-screen .logo-circle img {
    height: 180%;
    margin-top: 20%;
  }
}
</style>
